module.exports = __webpack_public_path__ + "img/shark.14cb9754.png";